import React, { useState, useMemo } from "react"
import { useTheme, useMediaQuery, Box, Paper } from "@material-ui/core"
import FileSelector from "./file-selector"
import FileContentViewer from "./file-content-viewer"
import useStore from "src/v2/utils/store"
import useASTStore from "../../../utils/AST-store"

/**
 * @param props {{
 *  solFiles: { path: string, content: string }[],
 *  initialFile?: string
 * }}
 */
export default function FileViewer({ solFiles, initialFile }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"))
  const fileList = useMemo(() => solFiles || [], [solFiles])

  // Use store for selectedFile
  const selectedFile = useASTStore((state) => state.selectedFile)
  const setSelectedFile = useASTStore((state) => state.setSelectedFile)

  // Set default selected file if not already set
  React.useEffect(() => {
    if (!selectedFile && (initialFile || fileList[0]?.path)) {
      setSelectedFile(
        initialFile && fileList.some((f) => f.path === initialFile)
          ? initialFile
          : fileList[0]?.path || "",
      )
    }
    // eslint-disable-next-line
  }, [initialFile, fileList])

  return (
    <Box
      style={{
        overflow: "hidden",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        background: "#f6f6fa",
        width: "100%",
        height: "100%",
      }}
    >
      <Paper
        elevation={2}
        style={{
          padding: isMobile ? 8 : 15,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
          background: "#fff",
        }}
      >
        <Box>
          <FileSelector
            solFiles={fileList}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
          />
        </Box>
        <Box
          style={{
            flex: 1,
            marginTop: isMobile ? 8 : 14,
            minHeight: 0,
            borderRadius: 8,
          }}
        >
          <FileContentViewer
            solFiles={fileList}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
          />
        </Box>
      </Paper>
    </Box>
  )
}
